import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Mail,
  LogOut,
  Menu,
  X,
  Shield,
  CreditCard,
  Layers,
} from "lucide-react";
import Cookies from "js-cookie";
import { clearAuthSessionCookies } from "@/lib/authCookies";

const menuItems = [
  { path: "/admin", label: "Overview", icon: LayoutDashboard, exact: true },
  { path: "/admin/users", label: "Users", icon: Users },
  { path: "/admin/leads", label: "Lead Inquiries", icon: Mail },
  { path: "/admin/stripe", label: "Stripe", icon: CreditCard },
  { path: "/admin/tariffs", label: "Tariffs", icon: Layers },
];

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const email = Cookies.get("email") || "";

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    clearAuthSessionCookies();
    navigate("/login");
  };

  const isActive = (path, exact) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <button
        type="button"
        className="md:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-white/5 border border-white/10 text-[#F3F4F6]"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>

      {isOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/60 z-40"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-full w-64 bg-[#06080C] border-r border-white/10 z-40 transform transition-transform duration-200 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0`}
        data-testid="admin-sidebar"
      >
        <div className="flex flex-col h-full">
          <div className="px-6 py-6 border-b border-white/10">
            <div className="flex items-center gap-2 text-[#F3F4F6]">
              <Shield className="w-5 h-5 text-[#00D1FF]" />
              <span className="font-heading font-semibold">Admin</span>
            </div>
            {email && (
              <p className="mt-2 text-xs text-[#9CA3AF] truncate">{email}</p>
            )}
          </div>

          <nav className="flex-1 px-3 py-4 space-y-1">
            {menuItems.map(({ path, label, icon: Icon, exact }) => {
              const active = isActive(path, exact);
              return (
                <Link
                  key={path}
                  to={path}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                    active
                      ? "bg-[#00D1FF]/10 text-[#00D1FF] border border-[#00D1FF]/20"
                      : "text-[#9CA3AF] hover:text-[#F3F4F6] hover:bg-white/5"
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {label}
                </Link>
              );
            })}
          </nav>

          <div className="px-3 py-4 border-t border-white/10">
            <button
              type="button"
              onClick={handleLogout}
              className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm text-[#9CA3AF] hover:text-[#F3F4F6] hover:bg-white/5 transition-colors"
            >
              <LogOut className="w-4 h-4" />
              Log out
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;
